import { AbstractControl, ValidationErrors } from '@angular/forms';

export class CustomValidators {
  static noSpecialCharsOrSpaces(control: AbstractControl): ValidationErrors | null {
    const pattern = /^[a-zA-Z0-9]+$/;
    if (!control.value || pattern.test(control.value)) {
      return null; // Walidacja OK
    }
    return { invalidCharacters: true };
  }
}
